import { useState, useEffect, React } from "react";
import $ from 'jquery';
// core components
import './Vision.css';
import Footer from "../Footer/Footer.js";
import Loader from "../../components/loader/loader.js";
import Bannervison from "../../assets/images/bannervison.png"
import Mission from "../../assets/images/mission.png"
import Circle from "../../assets/images/circle.png"
import {Link} from "react-router-dom";

export default function Home() {
   const [loading, setLoading] = useState(true);
 
   useEffect(() => {
     const timer = setTimeout(() => {
       setLoading(false);
     }, 2500); 
 
     return () => clearTimeout(timer);
   }, []);
   $(window).scroll(function () {
    if ($(this).scrollTop()) {
      $('header').addClass('fixedTop');
    } else {
      $('header').removeClass('fixedTop');
    }
  });
  useEffect(() => {
     window.scrollTo(0, 0)
   }, [])
  return (
<div>
{loading ? <Loader /> :
    <div>
        <div className="vision_header">
          <section className="vision_banner">
            <div className="container-fluid custom-container">
               <div className="row">
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_text">
                        <h1>OUR MISSION & VISION</h1>
                       </div>
                  </div>
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_img">
                     <img src={Bannervison} alt="Vision Banner" className="img-fluid"/>
                     </div>
                  </div>
               </div>
               </div>
            
                  
            </section>
            <section className="vision_content">
               <div className="container-fluid custom-container">
                  <div className="vision_content_text">
                  <div className="row">
                     <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <div className="vision_text">
                           <h2>Our Vision</h2>
                           <p>To create a world where visually impaired individuals are empowered to be independent in every aspect of life with the help of advanced assistive technologies, and where elderly citizens receive emotional and health support in a dignified, respectful manner.</p>
                        </div>
                     </div>
                  </div>
                  </div>
               </div>
               </section>
               <section className="mission_content">
               <div className="container-fluid custom-container">
                  <div className="mission_content_text"> 
                  <div className="row">
                     <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <img src={Mission} alt="Mission" className="img-fluid"/>
                     </div>
                     <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <div className="mission_text">
                           <h2>Our Mission</h2>
                           <h3>We aim to uplift lives through:</h3>
                           <ul>
                              <li>Inclusive education</li>
                              <li>Skill-building and communication training</li>
                              <li>Health and wellness support</li>
                              <li>Smart technology access</li>
                              <li>Emotional and moral companionship</li>
                           </ul>
                           <p>We don’t just serve—we walk the journey with those we support. It is the society’s responsibility to not only enable but also ensure that the roadmap for a successful life is accessible to the specially challenged.</p>
                        </div>
                     </div>
                  </div>
                  </div>
               </div>
                  </section>
                  <section className="vision_circle">
                  <div className="container-fluid custom-container">
                     <div className="vision_circle_text">
                        <h2>Our Core Values</h2>
                        <div className="row">
                           <div className="col-lg-2 col-md-2 col-sm-12 col-12"></div>
                           <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                              <div className="vision_flex">
                                 <img src={Circle} alt="Circle" className="img-fluid"/>
                              <h3>Compassion- With empathy and purpose</h3>
                              </div>
                              <div className="vision_flex mt-3">
                                 <img src={Circle} alt="Circle" className="img-fluid"/>
                              <h3>Empowerment- Encouraging potential</h3>
                              </div>
                           </div>
                           <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="vision_flex">
                                 <img src={Circle} alt="Circle" className="img-fluid"/>
                              <h3>Dignity- Everyone matters</h3>
                              </div>
                              <div className="vision_flex mt-3">
                                 <img src={Circle} alt="Circle" className="img-fluid"/>
                              <h3>Inclusion- No one left behind</h3>
                              </div>
                           </div>
                             <div className="col-lg-2 col-md-2 col-sm-12 col-12"></div>
                        </div>
                        <div className="vision_flex_button">
                     <Link to="/Donate"><button class="button_svg"> Donate Now <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
                        <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z" clip-rule="evenodd"></path>
                      </svg>
                    </button></Link>
                           </div>
                     </div>                   
                  </div>                   
                  </section>
           <Footer />
        </div>
     
    </div>
    }
    </div>
  )
}
